// extracted by mini-css-extract-plugin
export default {"select-all":"LnR6Pv3Io6","selectAll":"LnR6Pv3Io6","group":"nkyp+mTlrr","right-label":"_2w7ZsorQbZ","rightLabel":"_2w7ZsorQbZ","grant-type":"yO+WDxeSzK","grantType":"yO+WDxeSzK","description":"AjDBUoXheS"};
    if(module.hot) {
      // 1650538150107
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  